import { render, staticRenderFns } from "./SupportCard.vue?vue&type=template&id=277c1dc2"
import script from "./SupportCard.vue?vue&type=script&lang=js"
export * from "./SupportCard.vue?vue&type=script&lang=js"
import style0 from "./SupportCard.vue?vue&type=style&index=0&id=277c1dc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports